<template>
    <div id="select-carte-own-group"
         class="form-group">
        <label for="select-carte-own">Dernières cartes créées aujourd'hui :</label>
        <button class="btn btn-secondary" v-on:click="getCards">mettre à jour</button>
        <b-alert show v-if="searching === null">cliquer sur le bouton mettre à jour pour afficher les cartes du jour</b-alert>
        <b-alert show v-if="searching">Recherche en cours..</b-alert>
        <b-alert variant="warning" show v-if="searching === false && availableCards.length === 0">Aucune carte trouvée
            pour aujourd'hui, utilisez la recherche.
        </b-alert>
        <select v-if="!searching && availableCards.length > 0" id="select-carte-own"
                v-model="selectedCard"
                class="custom-select"
                @change="$emit( 'change-selected', selectedCard)">
            <option v-for="card in availableCards" v-bind:value="{ id: card.id, name: card.name, desc: card.desc }">
                {{ card.name }}
            </option>
        </select>
    </div>
</template>

<script>

  export default {

    name: 'Cards',

    props: ['cardsType'],

    data() {
      return {
        selectedCard: {},
        availableCards: [],
        availableBoards: [],
        searching: null
      }
    },

    mounted() {
      console.log(this.cardsType)
      //this.getCards()
    },

    methods: {

      getCards: function (e) {
        e.preventDefault()
        console.log('recherche des boards')
        this.searching = true
        window.Trello.get('members/me/boards', this.parcoursBoards)
        // on laisse un délai de 4 secondes pour la recherche
        setTimeout(() => {
          this.searching = false
        }, 4000)
      },

      parcoursBoards: function (datas) {
        console.log('parcours des boards')
        let now = new Date()
        let params = {
          since: now.toISOString().substring(0, 10), //date du jour au format AAAA-MM-JJ
        }
        for (let i = 0; i < datas.length; i++) {
          console.log('récupération des cartes')
          this.availableBoards.push({id: datas[i].id, name: datas[i].name})
          window.Trello.get('/boards/' + datas[i].id + '/cards', params, this.getCardsForBoards)
        }
      },

      getCardsForBoards: function (datas) {
        for (let i = 0; i < datas.length; i++) {
          let creationDate = new Date(parseInt(datas[i].id.substring(0, 8), 16) * 1000) // TODO pourrait être un service
          let newCard = {
            id: datas[i].id,
            name: datas[i].name,
            desc: datas[i].desc,
            creationDate: creationDate,
          }
          this.availableCards.push(newCard)
          this.availableCards.sort(compareFunction)
          // à partir du moment ou au moins un board est parcouru on a des donné à afficher, on passe la recherche à false
          this.searching = false
        }

        function compareFunction(a, b) {
          console.log('sort')
          if (a.creationDate > b.creationDate) {
            return -1
          }
          if (a.creationDate < b.creationDate) {
            return 1
          } else {
            return 0
          }
        }
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/AssociateSub/Cards.vue